/* src/app/modules/portal/components/companions-panel/companions-panel.component.scss */
.items {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  overflow: hidden;
}
.items .item {
  display: flex;
  flex-direction: column;
}
.items .item sh-text {
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  max-width: 68px;
}
.items .item [top-line] {
  margin-top: 4px;
}
sh-tool[disabled] {
  opacity: 0.7;
}
sh-text[size=header-2] {
  margin-bottom: 1rem;
}
/*# sourceMappingURL=companions-panel.component.css.map */
